export const generateDigitalData = (pathname: string, languageCountryPair: { language: string, country: string }) => {

  const routeKey = pathname.replace(/^\/\S\S-\S\S/,"").
    replace(/^\/|\/$/g,"").
    replace(/-/g," "),
    slots = routeKey.split("/");

  const siteSection = slots[0];
  const hierarchy = "fpro:" + slots.slice(0, 2).join(":");
  const pageName = "fpro:" + slots.join(":");
  const pageNameNoVehicle = "fpro:" + slots.join(":");


  return {
    page: {
      siteSection: siteSection,
      hierarchy: hierarchy,
      pageName: pageName,
      pageNameNoVehicle: pageNameNoVehicle,
      client: regionToClient[languageCountryPair.country],
      country: languageCountryPair.country,
      site: regionToSite[languageCountryPair.country],
      userLanguage: userLanguages[languageCountryPair.language],
      radUIVersion: getRadUiVersion(window.innerWidth),
    },
    user: {
      loginStatus: getLoggedInStatus(),
    }
  };
};

export const track = (tag: string, languageCountryPair: { language: string, country: string }) => {
  window.digitaldata = generateDigitalData(window.location.pathname, languageCountryPair);
  if (window._satellite) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
    window._satellite.track(tag);
  }
};

export const getRadUiVersion = (pageWidth: number) => {
  if (pageWidth < 768) {
    return 'ui:rad:mobile';
  }
  if (pageWidth < 992) {
    return 'ui:rad:tablet';
  }
  return 'ui:rad:pc';
};

export const getLoggedInStatus = () => {
  if(window.env?.USER) {
    return "logged in";
  }
  return "logged out";
}
type StringKeyedObject = Record<string, string>;

const regionToSite: StringKeyedObject = {
  "us": "pro.ford.com",
  "ca": "pro.ford.ca",
}

const userLanguages: StringKeyedObject = {
  "en": "eng",
  "fr": "fre",
}

const regionToClient: StringKeyedObject = {
  "us": "fpro-us",
  "ca": "fpro-can",
}
